export default function Phone({ tel }: { tel: string }) {
  const phone = `1.${tel.substring(0, 3)}.${tel.substring(3, 6)}.${tel.substring(6, 10)}`;
  return (
    <span>
      { phone }
    </span>
  );
};